/**
 * eslint-disable react-hooks/exhaustive-deps
 *
 * @format
 */

import { useState, useEffect, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { toast } from "react-toastify";
import TableSearch from "../../0-ResuableComponents/tableComponents/TableSearch";
import Pagination from "../../0-ResuableComponents/pagination/Pagination";
import ConfirmDialog from "../../0-ResuableComponents/confirmDialog/ConfirmDialog";
import VariantForm from "./VariantForm";
import ProductVariantsTable from "./ProductVariantsTable";
import { serialize } from "object-to-formdata";
import { singleProduct } from "../../../actions/productActions";
import {
  createNewVariant,
  updateVariant,
  deleteVariant,
  allVariantsByProduct,
  filtersBySubcategory,
} from "../../../actions/variantActions";

const variant_initData = {
  name: "",
  type: "",
  productId: "",
  skuId: "",
  costPrice: "",
  sellingPrice: "",
  hsn: "",
  videoLink: [""],
  outOfStock: "",
  quantity: "",
  volume: { unit: "", value: "" },
  weight: { unit: "", value: "" },
  photoUrl: [],
  price: { mrp: "", min: "", max: "" },
  purchaseQtyLimit: "",
  status: "",
  deliveryFee: "",
  packagingMaterial: "",
  packagingCost: "",
  deliveryTime: "",
  minOrderQuantity: "",
  weightUnit:"",
  volumeUnit:"",
  photoUrlofPackagedProduct: [],
};

const CreateVariant = ({ match }) => {
  const [variant, setVariant] = useState(variant_initData);
  const [selectedFilters, setSelectedFilters] = useState({});
  const { auth } = useSelector((state) => ({ ...state }));
  const { token } = auth;
  const history = useHistory();
  const [variantList, setVariantList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [currentId, setCurrentId] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const singleVariant = currentId
    ? variantList.variants.find((variant) => variant._id === currentId)
    : null;

  const fetchProduct = async () => {
    let res = await singleProduct(token, match.params.productId);
    setSelectedProduct(res.data);
    console.log('res.data: ', res.data);
  };

  const fetchAllVariants = async () => {
    let res = await allVariantsByProduct(token, match.params.productId);
    setVariantList(res.data);
  };
  const fetchAllFilters = async () => {
    let res = await filtersBySubcategory(token, match.params.productId);
    setFilterList(res.data.productFilters);
  };
  const redirect = () => {
    history.push("/catalog/products");
  };

  const {
    name,
    type,
    quantity,
    skuId,
    costPrice,
    sellingPrice,
    hsn,
    videoLink,
    outOfStock,
    volume,
    weight,
    photoUrl,
    price,
    purchaseQtyLimit,
    status,
    weightUnit,
    volumeUnit,
    deliveryFee,
    packagingMaterial,
    packagingCost,
    deliveryTime,
    minOrderQuantity,
    photoUrlofPackagedProduct,
  } = variant;

  useEffect(() => {
    fetchAllVariants();
    fetchAllFilters();
    fetchProduct();
    if (singleVariant) setVariant(singleVariant);
  }, [currentId]);

  const clear = () => {
    //setCurrentId(0);
    setVariant({
      name: "",
      type: "",
      quantity: "",
      skuId: "",
      costPrice: "",
      sellingPrice: "",
      hsn: "",
      videoLink: [""],
      outOfStock: "",
      volume: { unit: "", value: "" },
      weight: { unit: "", value: "" },
      photoUrl: "",
      price: { mrp: "", min: "", max: "" },
      purchaseQtyLimit: "",
      status: "",
      deliveryFee: "",
      packagingMaterial: "",
      packagingCost: "",
      deliveryTime: "",
      photoUrlofPackagedProduct: "",
      minOrderQuantity: "",
      filters: {},
    });
  };

  const variantsData = useMemo(() => {
    let computedVariants = variantList?.variants;

    if (search) {
      computedVariants = computedVariants?.filter((variant) =>
        variant?.name?.toLowerCase().includes(search.toLowerCase())
      );
    }

    //Sorting variants
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedVariants = computedVariants?.sort(
        (a, b) => reversed * a[sorting.field]?.localeCompare(b[sorting.field])
      );
    }

    return computedVariants;
  }, [variantList, search, sorting]);
  let variantData = new FormData();
  const object = {
    name,
    type,
    skuId,
    costPrice,
    sellingPrice,
    hsn,
    videoLink,
    outOfStock,
    productId: match.params.productId,
    quantity,
    volume: {
      unit: volume.unit,
      value: volume.value,
    },
    weight: {
      unit: weight.unit,
      value: weight.value,
    },
    mrp: price.mrp || "",
    minPrice: price.min || "",
    maxPrice: price.max || "",
    purchaseQtyLimit,
    status,
    filters: selectedFilters,
    photoUrl,
    deliveryFee,
    packagingMaterial,
    packagingCost,
    deliveryTime,
    minOrderQuantity,
    photoUrlofPackagedProduct,
  };

  if (photoUrl.length > 8) {
    toast.error("You cannot upload more than 8 images");
    return;
  } else {
    if (photoUrl && photoUrl.length) {
      for (let ind = 0; ind < photoUrl.length; ind++) {
        variantData.append(`photoUrl[${ind}]`, photoUrl[ind]);
      }
    }
  }

  if (photoUrlofPackagedProduct.length > 8) {
    toast.error("You cannot upload more than 8 images");
    return;
  } else {
    if (photoUrlofPackagedProduct && photoUrlofPackagedProduct.length) {
      for (let ind = 0; ind < photoUrlofPackagedProduct.length; ind++) {
        variantData.append(
          `photoUrlofPackagedProduct[${ind}]`,
          photoUrlofPackagedProduct[ind]
        );
      }
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("images ==> ", photoUrl, typeof photoUrl);

    let variantData = new FormData();

    // let data = createFormData(variant);

    // variantData.append("name", name);
    // variantData.append("type", type);
    // variantData.append("skuId", skuId);
    // variantData.append("costPrice", costPrice);
    // variantData.append("sellingPrice", sellingPrice);
    // variantData.append("hsn", hsn);
    // variantData.append("videoLink", videoLink);
    // variantData.append("outOfStock", outOfStock);
    // variantData.append("productId", match.params.productId);
    // variantData.append("quantity", quantity);
    // variantData.append(`volume.unit`, volume.unit);
    // variantData.append(`volume.value`, volume.value);
    // variantData.append(`weight.unit`, weight.unit);
    // variantData.append(`weight.value`, weight.value);
    // //photoUrl && variantData.append("photoFile", photoUrl);
    // variantData.append(`mrp`, price.mrp || "");
    // variantData.append(`minPrice`, price.min || "");
    // variantData.append(`maxPrice`, price.max || "");
    // variantData.append("purchaseQtyLimit", purchaseQtyLimit);
    // variantData.append("status", status);
    // variantData.append("filters", selectedFilters);

    // if (photoUrl.length > 8) {
    //   toast.error("You can not upload more than 8 images");
    //   return;
    // } else {
    //   if (photoUrl && photoUrl.length) {
    //     for (let ind = 0; ind < photoUrl.length; ind++) {
    //       variantData.append(`photoUrl[${ind}]`, photoUrl[ind]);
    //     }
    //   }
    // }
    const formData = serialize(object);
    try {
      if (currentId === 0) {
        await createNewVariant(token, formData);
        fetchAllVariants();
        toast.success(
          `Your New Variant ${variant.name} is added Successfully...`
        );
        clear();
        handleClose();
      } else {
        console.log("variantData: ", formData, object);
        setConfirmDialog({
          isOpen: true,
          title: "Are you sure to Update this record?",
          subTitle: "You can't undo this operation",
          onConfirm: async () => {
            setConfirmDialog({
              ...confirmDialog,
              isOpen: false,
            });
            await updateVariant(token, formData, currentId)
              .then(() => {
                fetchAllVariants();
                toast.success(
                  `Your Variant ${variant.name} is updated Successfully...`
                );
                clear();
                handleClose();
              })
              .catch((err) => toast.error(err));
          },
        });
      }
    } catch (err) {
      toast.error(err.response.data.errorMessage);
    }
  };

  const handleImageChange = (e, index) => {
    const { files } = e.target;
    // const newImage = [...variant.photoUrl];
    // // extract the first file from the array

    // newImage[index] = file;
    if (files.length > 8) {
      toast.error("You can not select more than 8 images");
      return;
    }
    setVariant({ ...variant, photoUrl: files });
  };

  const handlePackagedProductImageChange = (e, index) => {
    const { files } = e.target;
    // const newImage = [...variant.photoUrl];
    // // extract the first file from the array

    // newImage[index] = file;
    if (files.length > 8) {
      toast.error("You can not select more than 8 images");
      return;
    }
    setVariant({ ...variant, photoUrlofPackagedProduct: files });
  };
  const handleChange = (e) => {
    setVariant({ ...variant, [e.target.name]: e.target.value });
  };

  const handleVariantDelete = async (variantId) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteVariant(token, variantId)
      .then((res) => {
        toast.success("Variant Deleted successfully...");
        fetchAllVariants();
      })
      .catch((err) => toast.error(err.response.data.errorMessage));
  };

  // Get current rows
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = variantsData?.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  //console.log("ppppp", selectedFilters);
  return (
    <div id='layoutSidenav_content'>
      <main>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-5 col-md-9 col-lg-6'>
              <h2 className='mt-30 page-title'>
                {selectedProduct?.product?.name} &#62;
              </h2>
            </div>
            <div className='col-lg-5 col-md-3 col-lg-6 back-btn'>
              <Button variant='contained' onClick={redirect}>
                <i className='fas fa-arrow-left' /> Back
              </Button>
            </div>
          </div>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item'>
              <Link to='/dashboard'>Dashboard</Link>
            </li>
            <li className='breadcrumb-item active'>
              <Link to='/catalog/products'>Product</Link>
            </li>
            <li className='breadcrumb-item active'>Variants</li>
          </ol>
          <div className='col-lg-12 col-md-12 back-btn'>
            <button
              className='save-btn hover-btn'
              onClick={() => {
                setCurrentId(0);
                handleShow();
                // clear();
              }}
            >
              + Add New Variant
            </button>
          </div>
          <TableSearch
            onSearch={(value) => {
              setSearch(value);
            }}
            placeholder='Search by Variant Name'
          />
          <VariantForm
            variant={variant}
            setVariant={setVariant}
            handleSubmit={handleSubmit}
            handleImageChange={handleImageChange}
            handlePackagedProductImageChange={handlePackagedProductImageChange}
            handleChange={handleChange}
            currentId={currentId}
            show={show}
            setSelectedFilters={setSelectedFilters}
            filterList={filterList}
            handleClose={handleClose}
          />
          <div className='row'>
            <ProductVariantsTable
              variantList={currentRows}
              setCurrentId={setCurrentId}
              handleVariantDelete={handleVariantDelete}
              setConfirmDialog={setConfirmDialog}
              setSorting={setSorting}
              handleShow={handleShow}
              setVariant={setVariant}
            />
            <Pagination
              rowsPerPage={rowsPerPage}
              totalRows={variantList?.variants?.length}
              paginate={paginate}
              setRowsPerPage={setRowsPerPage}
              url={`/catalog/products/variants/${match.params.categoryId}`}
            />
          </div>
        </div>
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </main>
    </div>
  );
};

export default CreateVariant;
